import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { usePopunder } from 'hooks/usePopunder';
import { useSystemSearchQueries } from 'hooks/useSystemSearchQueries';

export const useRetentionPopunder = () => {
  const { pathname, search } = useLocation();

  const { openPopunder } = usePopunder();

  const { getTargetPathQuery } = useSystemSearchQueries();

  const { value: targetPath, key: targetQuery } = getTargetPathQuery();

  const initRetentionPopunder = () => {
    // ? (pathname !== '/one-click/auth') needed to open popunder and start payment exactly on /one-click/auth page
    if (targetPath && pathname !== '/one-click/auth') {
      window.document.body.addEventListener(
        'click',
        (e: any) => {
          e.stopPropagation();
          const queries = queryString.parse(search);
          delete queries[targetQuery];

          openPopunder({
            activeTabUrl: `${pathname}?${queryString.stringify(queries)}`,
            backgroundTabUrl: `https://${targetPath}?${queryString.stringify(
              queries
            )}`,
          });
        },
        true
      );
    }
  };

  return {
    initRetentionPopunder,
  };
};
